export let variables_store = {
    state() {
        return {
            links: {
                common: [],
                admin: []
            }
        }
    }
}